import type { Podcast } from '@/types';
import { PodcastCard } from './PodcastCard';

interface PodcastGridProps {
  podcasts: Podcast[];
  onPodcastClick: (podcast: Podcast) => void;
  isLoading?: boolean;
  emptyMessage?: string;
}

export function PodcastGrid({
  podcasts,
  onPodcastClick,
  isLoading = false,
  emptyMessage = 'No podcasts found',
}: PodcastGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={i} className="glass-panel animate-pulse">
            <div className="aspect-square mb-3 rounded-lg bg-white/5" />
            <div className="h-4 bg-white/5 rounded mb-2" />
            <div className="h-3 bg-white/5 rounded w-2/3" />
          </div>
        ))}
      </div>
    );
  }

  if (podcasts.length === 0) {
    return (
      <div className="text-center py-12 text-white/60">
        <svg
          className="w-16 h-16 mx-auto mb-4 text-white/20"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
          />
        </svg>
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
      {podcasts.map((podcast) => (
        <PodcastCard
          key={podcast.id}
          podcast={podcast}
          onClick={onPodcastClick}
        />
      ))}
    </div>
  );
}
